/**
 * Per-graph-instance variable storage (UE member + per-call local child stores).
 */
export class VariableStore {
    values = new Map();
    constIds = new Set();
    listeners = new Set();
    parent;
    constructor(definitions = [], parent = null) {
        this.parent = parent;
        for (const definition of definitions) {
            this.values.set(definition.id, definition.defaultValue);
            if (definition.isConst)
                this.constIds.add(definition.id);
        }
    }
    /**
     * Child store for a function call: owns local variables, reads/writes graph
     * variables through the parent.
     */
    createLocalChild(locals) {
        const definitions = Object.entries(locals).map(([id, defaultValue]) => ({
            id,
            defaultValue
        }));
        return new VariableStore(definitions, this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        const parentUnsub = this.parent?.subscribe(listener) ?? null;
        return () => {
            this.listeners.delete(listener);
            parentUnsub?.();
        };
    }
    isConst(variableId) {
        if (this.constIds.has(variableId))
            return true;
        return this.parent?.isConst(variableId) ?? false;
    }
    hasLocal(variableId) {
        return this.values.has(variableId);
    }
    get(variableId) {
        if (this.values.has(variableId))
            return this.values.get(variableId);
        return this.parent?.get(variableId);
    }
    set(variableId, value) {
        if (this.isConst(variableId))
            return false;
        if (this.values.has(variableId) || !this.parent) {
            this.values.set(variableId, value);
            this.notify(variableId);
            return true;
        }
        return this.parent.set(variableId, value);
    }
    notify(variableId) {
        for (const listener of this.listeners) {
            listener(variableId);
        }
    }
}
